import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { isApp } from 'sg-ui-components';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

const Register = ({ user, config, cmsSourceFirebase, actions, match }) => {
    const [registrationUrl, setRegistrationUrl] = useState('');

    useEffect(() => {
        if (config?.config?.registration_host_uri && !user?.loggedIn) {
            if (isApp()) {
                let myLocation = typeof window !== 'undefined' ? window.location.protocol + '//' + window.location.host + '/home' : '';
                // remove any trailing slashes
                myLocation = myLocation.replace(/\/$/, '');

                //? for debug: console.log('🚀 triggerApp openRegister: /register', myLocation);
                window.parent.postMessage(
                    {
                        message: 'openRegister',
                        redirect: myLocation,
                    },
                    '*'
                );
            } else {
                setRegistrationUrl(config?.config?.registration_host_uri ?? '');
            }
        }
    }, [config?.config?.registration_host_uri, user?.loggedIn]);

    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            {user.loggedIn ? <Redirect to='/enter' /> : null}
            <div className='my-5 text-center'>
                <h3>
                    Redirecting to registration page:
                    <a href={registrationUrl}>{!user.loggedIn && registrationUrl ? window.location.replace(registrationUrl) : null}</a>
                </h3>
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
